var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentMatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.482,
    height: 36.474,
    viewBox: "0 0 36.482 36.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employee_12_",
    "data-name": "employee (12)",
    transform: "translate(0 -0.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52741",
    "data-name": "Path 52741",
    d: "M18.465,250.357a10.078,10.078,0,0,1,5.012-8.706C13.885,234.577-.066,241.63,0,253.639v3.586a1.069,1.069,0,0,0,1.069,1.069H22.341a10.061,10.061,0,0,1-3.876-7.936",
    transform: "translate(0 -221.766)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52742",
    "data-name": "Path 52742",
    d: "M105.972,8.561A8.508,8.508,0,0,0,97.464.053c-11.286.448-11.283,16.57,0,17.016a8.508,8.508,0,0,0,8.508-8.508m12.005,15.907-6.023,6.023a1.069,1.069,0,0,1-1.511,0L108.154,28.2a1.069,1.069,0,0,1,1.511-1.511l1.533,1.534,5.422-5.422a7.931,7.931,0,1,0,1.356,1.666",
    transform: "translate(-82.661)",
    fill: "#3db6fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentMatching);
export default __webpack_public_path__ + "static/media/Talent Matching.d61c965035a6355bc59aeb9ae0bbc347.svg";
export { ForwardRef as ReactComponent };